module.exports = __webpack_public_path__ + "img/movie-trailer.adaa1cd9.webp";